import axiosHttpClient from "../axiosHttpClient";

export async function getAll() {
	return axiosHttpClient.get('/recipes/lab');
}
